import { AbstractControl } from '@angular/forms';

export interface RequiredRule {
  label: string;
  /** Control path checked for a blank value. Ignored when `missing` is given. */
  control?: string;
  /** Rule only applies when this returns true. */
  when?: () => boolean;
  /** Custom check; return true when the requirement is NOT met. */
  missing?: () => boolean;
}

export function isBlankValue(v: any): boolean {
  if (v == null) return true;
  if (typeof v === 'string') return v.trim() === '';
  if (Array.isArray(v)) return v.length === 0;
  return false;
}

/** Labels of required fields that are still empty, in rule order (drives the footer "Required: ..." hint). */
export function requiredMissing(
  form: AbstractControl | null | undefined,
  rules: RequiredRule[]
): string[] {
  if (!form) return [];
  return rules
    .filter(r => !r.when || r.when())
    .filter(r => (r.missing ? r.missing() : r.control ? isBlankValue(form.get(r.control)?.value) : false))
    .map(r => r.label);
}
